<template>
  <div class="container">
    <div class="cate">
      <div class="cate_police">
        <div class="cate-all">组织方式：</div>
        <div class="subject">
          <span
              v-for="(item, index) in ['管理员组织','学员组织']"
              :key="index"
              :class="{ heightlight: zhuzhiIndex == index }"
              @click="zhuzhiIndexChange(index, item)"
          >{{ item }}</span
          >
        </div>
      </div>
      <div class="cate_police">
        <div class="cate-all">考试模式：</div>
        <div class="subject">
          <span
            v-for="(item, index) in subTypeList"
            :key="index"
            :class="{ heightlight: examTypeindex == index }"
            @click="examType(index, item)"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <!-- <div class="cate_police">
        <div class="cate-all">考试类型：</div>
        <div class="subject">
          <span
            v-for="(item, index) in typeList"
            :key="index"
            :class="{ heightlight: typeindex == index }"
            @click="btnTypeindex(index, item)"
          >{{ item.name }}</span>
        </div>
      </div> -->
      <div style="border-bottom: 1px solid #dcdfe6" class="cate_police">
        <div class="cate-all">考试科目：</div>
        <div class="subject">
          <span
            v-for="(item, index) in policeClassification"
            :key="index"
            :class="{ heightlight: policeClassindex == index }"
            @click="policeClassArea(index, item)"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <!-- <div class="cate_police">
        <div class="cate-all">地市/州 ：</div>
        <div class="subject">
          <span
            v-for="(item, index) in cityList"
            :key="index"
            :class="{heightlight : cityIndex==index}"
            @click="selectCity(index,item)"
          >{{ item.name }}</span>
        </div>
      </div>-->
    </div>
    <div class="content">
      <div class="content_left">
        <div class="first">
          <div class="vertical_bar">
            <img src="@/assets/images/practice.png" />
          </div>
          <div class="title-box">
            <div class="title">
              <span>练习考试</span>
            </div>

            <div class="cate_police" style="display: flex; align-items: center">
              <!-- <div class="subject" style="padding-right: 30px">
                <span
                  v-for="(item, index) in newList"
                  :key="index"
                  style="margin-bottom: 0px;"
                  :class="{ heightlight: newIndex == index }"
                  @click="policeNew(index, item)"
                >{{ item.name }}</span>
              </div> -->
              <el-input
                size="large"
                placeholder="请输入搜索内容"
                v-model="listQuery.title"
                class="input-with-select"
                @change="getList"
                style="
                  width: 287px;
                  color: white;
                  height: 40px;
                  font-size: 16px;
                  border-radius: 4px;
                  flex-shrink: 0;
                  margin-right: 10px;
                "
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="getList"
                  style="
                    background: #545c63;
                    border-radius: 0px;
                    height: 100%;
                    color: white;
                    font-size: 16px;
                  "
                ></el-button>
              </el-input>
            </div>
          </div>
        </div>
        <!-- 渐变线条 -->
        <div class="gitern"></div>
        <div class="table">
          <el-table :data="tableData" style="width: 100%; font-size: 16px">
            <el-table-column
              prop="title"
              label="考试题目"
              show-overflow-tooltip
              min-width="200"
            >
              <template slot="header">
                <div style="text-align: center">考试题目</div>
              </template>
              <template slot-scope="scope">
                <span
                  class="buttton-text"
                  @click="Details(scope.row.paperId, scope.row.id, scope.row)"
                  >{{ scope.row.title }}</span
                >
              </template>
            </el-table-column>

            <el-table-column
              prop="subtype"
              label="考试模式"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <span v-for="(item, index) in subTypeList" :key="index">
                  <span v-if="item.subType == scope.row.subtype">
                    {{ item.name }}
                  </span>
                </span>
              </template>
            </el-table-column>

            <!-- <el-table-column prop="cateName" label="考试类别" min-width="80" align="center"></el-table-column> -->

            <el-table-column
              prop="subjectname"
              label="科目"
              align="center"
              min-width="140"
            ></el-table-column>

            <el-table-column
              prop="createtime"
              label="发布时间"
              align="center"
              width="150"
            ></el-table-column>

            <el-table-column
              prop="operate"
              label="操作"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="Details(scope.row.paperId, scope.row.id, scope.row)"
                  >开始练习</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="toolbar">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[20, 30, 40]"
              :page-size="listQuery.limit"
              layout="total, prev, pager, next, jumper"
              :total="dataCount"
              style="margin: 10px"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 正式考试 -->
      <div class="content_right" id="zhengshikao">
        <div class="examCardOne">
          <div class="examCardLabel">
            <img src="@/assets/images/examination.png" />
            <span>正在进行的考试</span>
          </div>
          <ul v-if="startExam.length > 0" class="examCardTable">
            <li v-for="(item, index) in startExam" :key="index">
              <div
                :title="item.title"
                @click="examTitle(item.paperId, item.id, item)"
              >
                {{ item.title }}
              </div>
              <div @click="examTitle(item.paperId, item.id, item)">
                正在进行
              </div>
            </li>
          </ul>
          <div v-else class="cardNoDate">
            <span>暂无数据</span>
          </div>
        </div>
        <!-- 即将开始的考试 -->
        <div class="examCardOne">
          <div class="examCardLabel">
            <img src="@/assets/images/examing.png" />
            <span>即将开始的考试</span>
          </div>
          <ul v-if="beginExam.length > 0" class="examCardTable">
            <li v-for="(item, index) in beginExam" :key="index">
              <div
                :title="item.title"
                @click="examTitle(item.paperId, item.id)"
              >
                {{ item.title }}
              </div>
              <div style="color: #feb200; cursor: auto">即将开始</div>
            </li>
          </ul>
          <div v-else class="cardNoDate">
            <span>暂无数据</span>
          </div>
        </div>

        <div class="monthlyExam">
          <div class="examTwoCardLabel">
            <img src="@/assets/images/examing.png" />
            <span>题库建设月度排行榜</span>
          </div>

          <div class="ranking">
            <div class="rankTypeBtns">
              <div
                :class="[{ activeBtn: rankingType === 1 }]"
                @click.prevent="rankingType = 1"
              >
                警种排行
              </div>
              <div
                :class="[{ activeBtn: rankingType === 2 }]"
                @click.prevent="rankingType = 2"
              >
                地市排行
              </div>
            </div>
            <div v-show="rankingType === 1">
              <div
                class="ranking_list"
                v-for="(item, index) in jzQuestion"
                :key="index"
              >
                <div
                  v-if="index < 10"
                  :class="[
                    { oneSort: index === 0 },
                    { twoSort: index === 1 },
                    { threeSort: index === 2 },
                  ]"
                >
                  {{ index + 1 }}
                </div>
                <div v-if="index < 10" :title="item.name">{{ item.name }}</div>
                <div v-if="index < 10">共计 {{ item.cnt }} 题</div>
              </div>
            </div>
            <div v-show="rankingType === 2">
              <div
                class="ranking_list"
                v-for="(item, index) in dsQuestion"
                :key="index"
              >
                <div
                  v-if="index < 10"
                  :class="[
                    { oneSort: index === 0 },
                    { twoSort: index === 1 },
                    { threeSort: index === 2 },
                  ]"
                >
                  {{ index + 1 }}
                </div>
                <div v-if="index < 10" :title="item.name">{{ item.name }}</div>
                <div v-if="index < 10">共计 {{ item.cnt }} 题</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      width="1200px"
      :visible.sync="enterDialogVisible"
      @close="closeDialog"
    >
      <EnterExamDialog
        v-if="enterDialogVisible"
        :titleExam="titleExam"
      ></EnterExamDialog>
    </el-dialog>

    <el-dialog
      width="70%"
      :visible.sync="enterDialogVisible2"
      center
      @close="closeDialog2"
    >
      <PracticalTestExamDialog
        v-if="enterDialogVisible2"
        :titleExam="titleExam"
        @closePraDialog="closePraDialog"
      ></PracticalTestExamDialog>
    </el-dialog>
    <!-- <linecom></linecom> -->
    <el-dialog
      title="自由选题"
      class="dialog-mini"
      :visible.sync="customDlogShow"
      :append-to-body="true"
      width="600px"
      top="10vh"
    >
      <custom-exam v-if="customDlogShow" ref="customExam"></custom-exam>
      <div slot="footer">
        <el-button @click="$refs.customExam.startExam()" type="primary"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInfo } from "@/utils/auth";
import vHeader from "../header/index";
import { SelectExam } from "../../api/exam/paper";
import * as Exam from "@/api/exam/exam";
import * as Dept from "@/api/pmi/dept";
import * as teacherInfo from "@/api/teacher/teacherInfo";
import EnterExamDialog from "./components/enterExamDialog";
import PracticalTestExamDialog from "./components/practicalTestExamDialog";
import linecom from "@/components/linecom/index";
import customExam from "./components/customExam.vue";
export default {
  components: {
    vHeader,
    EnterExamDialog,
    PracticalTestExamDialog,
    linecom,
    customExam,
  },
  data() {
    return {
      options1: [],
      value0: "",
      value1: "",
      value2: "",
      value3: "",
      //所有警种
      AllPolice: [],
      policeClassification: [{ name: "全部", id: 0 }], //全部警种
      policeClassindex: 0,
      zhuzhiIndex: 0,
      examTypeindex: 0, //高亮默认为全部
      beginExam: [],
      startExam: [],
      jzQuestion: [],
      dsQuestion: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 20,
      dataCount: 0,
      user: {},
      subTypeList: [
        { subType: 0, name: "全部" },
        { subType: 1, name: "练习考试" },
        { subType: 2, name: "刷题模式" },
        { subType: 3, name: "闯关模式" },
        // { subType: 4, name: '正式考试' },
      ],
      listQuery: {
          unitId: JSON.parse(this.$store.state.User.infos).unitId,
        subType: null,
        type: 2,
        subjectId: null,
        cateId: null,
        title: "",
        status: 1,
        page: 1,
        limit: 20,
      },
      listQuery2: {
        namespaceId: null,
        page: 1,
        limit: 50,
      },
      enterDialogVisible: false, //进入考试弹框
      enterDialogVisible2: false,
      customDlogShow: false,
      titleExam: "",
      newList: [
        { subType: 0, name: "最新" },
        { subType: 1, name: "最热" },
      ],
      newIndex: 0,
      cityList: [{ name: "全部", id: 0 }],
      cityIndex: 0,
      typeList: [{ name: "全部", id: 0 }],
      typeindex: 0,
      rankingType: 1,
    };
  },
  methods: {
    //查询类别
    btnTypeindex(index, item) {
      this.typeindex = index;
      if (item.id == 0) {
        this.listQuery.cateId = null;
      } else {
        this.listQuery.cateId = item.id;
      }
      this.getList();
    },

    //查询地市
    selectCity(index, item) {
      this.cityIndex = index;
    },
    //获取地市
    getDishi() {
      Dept.getCity().then((res) => {
        res.result.forEach((e) => {
          this.cityList.push({ name: e.name, id: e.id });
        });
      });
    },
    //查询新热
    policeNew(index, item) {
      this.newIndex = index;
    },

    selectType() {
      if (!this.listQuery.subType) {
        this.listQuery.subType = null;
      }
      this.getList();
    },

    closePraDialog() {
      this.enterDialogVisible2 = false;
    },
    closeDialog2() {
      localStorage.removeItem("paperId");
      localStorage.removeItem("Id");
      this.enterDialogVisible2 = false;
    },
    policeClassArea(index, item) {
      this.policeClassindex = index;
      if (item.id == 0) {
        this.listQuery.subjectId = null;
      } else {
        this.listQuery.subjectId = item.id;
      }
      this.getList();
    },
    zhuzhiIndexChange(index, item) {
      if (index == 1) {
        if (getInfo("tokens")) {
          localStorage.removeItem("oldtimes");
          this.customDlogShow = true;
        } else {
          window.clikLogin();
        }
      }
    },
    examType(index, item) {
      this.examTypeindex = index;
      if (item.subType == 0) {
        this.listQuery.subType = null;
      } else {
        this.listQuery.subType = item.subType;
        if (item.subType == 4) {
          document.querySelector("#zhengshikao").scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          this.listQuery.subType = null;
        }
      }

      this.getList();
    },
    getPmiDictionary(index, arr) {
      this.listQuery2.namespaceId = index;
      teacherInfo
        .getPmiDic(this.listQuery2)
        .then((response) => {
          response.result.forEach((e) => {
            arr.push({ name: e.name, id: e.id });
          });
        })
        .catch(() => {});
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      //this.AllExams = this.AllExam.slice(0, this.pageSize);
      this.getList();
    },
    police(index) {
      for (let i = 0; i < this.AllPolice.length; i++) {
        if (this.AllPolice[i].Status == true) {
          this.AllPolice[i].Status = false;
          this.AllPolice[index].Status = true;
        } else {
          this.AllPolice[index].Status = true;
        }
      }
    },
    //点击正式考试title
    examTitle(paperId, Id, row) {
      if (getInfo("tokens")) {
        localStorage.setItem("paperId", paperId);
        localStorage.setItem("Id", Id);
        this.titleExam = row.title;
        if (row.type == 1) {
          this.enterDialogVisible = true;
        } else if (row.type == 3) {
          this.enterDialogVisible2 = true;
        }
      } else {
        window.clikLogin();
      }
    },
    //关闭弹窗
    closeDialog() {
      // localStorage.removeItem('paperId')
      // localStorage.removeItem('Id');
      this.enterDialogVisible = false;
    },
    //点击开始练习
    Details(paperId, Id, row) {
      if (getInfo("tokens")) {
        localStorage.removeItem("oldtimes");
        localStorage.setItem("paperId", paperId);
        localStorage.setItem("Id", Id);
        if (row.subtype == 1) {
          this.$router.push({
            path: "/simulationExam",
          });
        } else if (row.subtype == 2) {
          this.$router.push({
            path: "/BrushTopic",
          });
        } else if (row.subtype == 3) {
          this.$router.push({
            path: "/Breakthrough",
          });
        }
      } else {
        window.clikLogin();
      }
    },
    getList() {
      sessionStorage.removeItem("list");
      this.tableData = [];
      SelectExam(this.listQuery).then((res) => {
        this.tableData = res.data;
        this.dataCount = res.count;
      });
      //获取即将考试列表数据

      Exam.BegingList().then((res) => {
        this.beginExam = res.result;
      });
      //获取正在进行考试列表数据

      Exam.StartList().then((res) => {
        this.startExam = res.result;
      });
    },
    //获取警种统计
    getJzIndexTongJi() {
      Exam.JzIndexTongJi().then((res) => {
        this.jzQuestion = res.result;
      });
    },
    ///地市统计
    getJzIndexCity() {
      Exam.JzIndexCity().then((res) => {
        this.dsQuestion = res.result;
      });
    },
  },
  created() {
    this.getList();
    this.getJzIndexTongJi();
    this.getJzIndexCity();
    this.getPmiDictionary(6, this.policeClassification); //获取警种数组
    this.getDishi();
    //this.getPmiDictionary(5, this.typeList); //获取类别数组
  },
};
</script>

<style lang="scss" scoped>
.content_right {
  width: 303px;
  min-height: 883px;
  margin-left: 20px;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
  .examCardOne {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
    min-height: 200px;
    box-sizing: border-box;
    padding: 19px 15px 12px 15px;
    margin-bottom: 12px;
    .examCardLabel {
      display: flex;
      align-items: center;
      margin-bottom: 13px;
      & > img {
        width: 20px;
        height: 20px;
      }
      & > span {
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #4d515a;
        margin-left: 8px;
      }
    }
    .examCardTable {
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
        & > div:nth-child(1) {
          color: #4d515a;
          font-size: 14px;
          line-break: 21px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        & > div:nth-child(2) {
          color: #4291fe;
          font-size: 12px;
          line-height: 18px;
          font-weight: 400;
          cursor: pointer;
          flex-shrink: 0;
          margin-left: 20px;
        }
      }
    }
    .cardNoDate {
      min-height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #7d899d;
      font-weight: 400;
      line-height: 18px;
    }
  }
  .monthlyExam {
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    padding: 19px 15px 5px 15px;
    min-height: 450px;
    .examTwoCardLabel {
      display: flex;
      align-items: center;
      margin-bottom: 11px;
      & > img {
        width: 20px;
        height: 20px;
      }
      & > span {
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #4d515a;
        margin-left: 8px;
      }
    }
    .ranking {
      .rankTypeBtns {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        & > div {
          cursor: pointer;
          width: 70px;
          height: 27px;
          background-color: #fff;
          color: #4192ff;
          font-size: 14px;
          line-height: 21px;
          font-weight: 500;
          border-radius: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .activeBtn {
          background-color: #4192ff;
          color: #ffffff;
        }
        div + div {
          margin-left: 13px;
        }
      }
      .ranking_list {
        display: flex;
        margin-bottom: 11px;
        & > div:nth-child(1) {
          flex-shrink: 0;
          height: 18px;
          min-width: 18px;
          border-radius: 3px;
          color: #768297;
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          background-color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 7px;
        }
        & > div:nth-child(2) {
          flex: 1;
          font-weight: 400;
          font-size: 14px;
          line-height: 21px;
          color: #31303f;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        & > div:nth-child(3) {
          flex-shrink: 0;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          color: #7d899d;
          margin-left: 10px;
          min-width: 70px;
          text-align: left;
        }

        .oneSort {
          background-color: #ffe8e3 !important;
          color: #ff7070 !important;
        }
        .twoSort {
          background-color: #ffedd2 !important;
          color: #ff9255 !important;
        }
        .threeSort {
          background-color: #fff4cc !important;
          color: #f4ad00 !important;
        }
      }
    }
  }
}
</style>

<style scoped>
.el-tabs--border-card {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: none;
}
/* 头部搜索 */
.cate {
  box-sizing: border-box;
  width: 1200px;
  background: #ffffff;
  margin: 0 auto;
  margin-top: 14px;
  border-radius: 4px;
  padding: 44px 28px 27px 35px;
}
.cate_police {
  display: flex;
  font-size: 16px;
}
.cate_police + .cate_police {
  margin-top: 12px;
}
.cate-all {
  width: 76px;
  font-size: 14px;
  line-height: 21px;
  margin-right: 10px;
}
.subject {
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding-right: 80px;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  height: 22px;
  padding: 0px 10px;
  color: #000;
  opacity: 1;
  border: 1px solid white;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 20px;
}
.subject > span:hover {
  border: 1px solid #649fed;
  color: #649fed;
  border-radius: 4px;
}

/deep/.input-with-select input {
  border-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
/deep/.input-with-select .el-input-group__append {
  border-color: #51565c;
}
/* 头部搜索 */
.content {
  display: flex;
  margin: 0 auto;
  margin-top: 14px;
  margin-bottom: 10px;
  width: 1200px;
  box-sizing: border-box;
  padding: 21px 14px 0px 14px;
  background: linear-gradient(to bottom, #97caf4 0%, #fff 300px, #fff 100%);
  border-radius: 4px;
}
.content_left {
  width: 846px;
  min-height: 1250px;
  margin-bottom: 44px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
}

.first {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 14px 0px 5px 31px;
  box-sizing: border-box;
}
.title {
  font-size: 16px;
  color: #000000;
  font-weight: bold;
  line-height: 24px;
}

.vertical_bar {
  height: 40px;
}

.vertical_bar > img {
  width: 40px;
  height: 40px;
}

.table {
  padding: 10px 27px;
}

.toolbar {
  margin-top: 25px;
  text-align: center;
}
.content_right_top {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 0 10px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  overflow: auto;
  background-color: #fff;
}

.more1 {
  font-size: 16px;
  /* margin-left: 126px; */
  padding-top: 2px;
}
.more2 {
  font-size: 18px;
  font-weight: 500;
  color: #285fbe;
  font-weight: bold;
}

/* 高亮 */
.heightlight {
  background-color: #649fed !important;
  color: #f8fafc !important;
}
.title-box {
  width: 100%;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cityst {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  justify-content: space-between;
  padding-bottom: 40px;
}
.selectTxt {
  width: 280px;
}
.gitern {
  height: 2px;
  width: 100%;
  background: linear-gradient(139deg, #1492ff, #d51919);
}
.buttton-text:hover {
  cursor: pointer;
  text-decoration-line: underline;
  color: #1492ff;
}
</style>

<style >
.title-text-up {
  overflow: hidden;
  text-overflow: ellipsis;
  display: box;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>